export default __webpack_public_path__ + "static/media/genvia.3c6f5613.png";